import React from "react";

import styles from "./Content.module.scss";

const Content = ({ maxWidth, ...rest }) => (
  <div {...rest} className={styles.base} style={{ maxWidth }} />
);

export default Content;
